export default __webpack_public_path__ + "static/media/email.f43011be.svg";